/**
 * Port of snippets/lw-color-hex.liquid for PLP swatch hydration.
 */
(function () {
  const MAP = {
    'horizon-white': '#ffffff',
    f75: '#ffffff',
    'liquid-black': '#000000',
    f74: '#000000',
    'comet-indigo': '#8162aa',
    m00: '#8162aa',
    'jasper-gray': '#606161',
    m01: '#606161',
    'nebula-red': '#672F32',
    f84: '#672F32',
    'asphalt-black': '#181818',
    f77: '#181818',
    'nightfall-blue': '#3c5283',
    f76: '#3c5283',
    'nimbus-gray': '#c9c9c9',
    f50: '#c9c9c9',
    'himalaya-white': '#dbdbdb',
    m06: '#dbdbdb',
    'millrace-blue': '#5c788f',
    m27: '#5c788f',
    'liquid-black/black': '#2a2a2a',
    m36: '#2a2a2a',
    'liquid-black/red': '#b55252',
    m38: '#b55252',
    'lunar-white/gray': '#f3f3f3',
    m37: '#f3f3f3',
    assc: '#ffffff',
    'aster-magenta': '#a882a3',
    m58: '#a882a3',
    'glacier-silver': '#c3cdd6',
    m56: '#c3cdd6',
    'yellow-street': '#ffffff',
    'green-dirt': '#ffffff',
    '000': '#ffffff',
    'quasar-red': '#da3023',
    m90: '#da3023',
    white: '#ffffff',
    'off-white': '#f8f8f0',
    cream: '#E5DAD3',
    ivory: '#fffff0',
    pearl: '#f0ead6',
    parchment: '#f4f1f1',
    ecru: '#c2b280',
    bone: '#f9f6ee',
    champagne: '#f7e7ce',
    linen: '#faf0e6',
    beige: '#f5f5dc',
    sand: '#c2b280',
    tan: '#d2b48c',
    camel: '#c19a6b',
    khaki: '#c3b091',
    taupe: '#8b7d6b',
    stone: '#928174',
    oatmeal: '#d4c5a9',
    nude: '#f2caaf',
    black: '#000000',
    charcoal: '#36454f',
    graphite: '#404040',
    gunmetal: '#2a3439',
    slate: '#708090',
    gray: '#918E8E',
    grey: '#918E8E',
    silver: '#c0c0c0',
    ash: '#b2beb5',
    pewter: '#96a8a1',
    smoke: '#9e9e9e',
    brown: '#a52a2a',
    chocolate: '#7b3f00',
    coffee: '#6f4e37',
    mocha: '#967969',
    caramel: '#c68642',
    chestnut: '#954535',
    espresso: '#3c2415',
    cognac: '#9a463d',
    walnut: '#773f1a',
    copper: '#b87333',
    blue: '#0F4867',
    navy: '#000080',
    cobalt: '#0047ab',
    royal: '#4169e1',
    teal: '#497E85',
    turquoise: '#40e0d0',
    sky: '#87ceeb',
    denim: '#1560bd',
    indigo: '#4b0082',
    petrol: '#006b77',
    midnight: '#191970',
    powder: '#b0e0e6',
    cyan: '#00bcd4',
    green: '#008000',
    sage: '#BEC7BA',
    olive: '#446F13',
    forest: '#228b22',
    hunter: '#355e3b',
    mint: '#98ff98',
    emerald: '#50c878',
    jade: '#00a36c',
    lime: '#32cd32',
    army: '#4b5320',
    moss: '#8a9a5b',
    red: '#cc0000',
    crimson: '#dc143c',
    scarlet: '#ff2400',
    burgundy: '#800020',
    wine: '#722f37',
    maroon: '#800000',
    rust: '#b7410e',
    brick: '#9c2b2e',
    cherry: '#de3163',
    coral: '#ff7f50',
    tomato: '#ff6347',
    terracotta: '#e2725b',
    pink: '#ffc0cb',
    'hot-pink': '#ff69b4',
    rose: '#ff66cc',
    blush: '#f4a6b0',
    mauve: '#e0b0ff',
    fuchsia: '#ff00ff',
    salmon: '#fa8072',
    peach: '#ffcba4',
    lilac: '#c8a2c8',
    'dusty-rose': '#dcae96',
    purple: '#800080',
    lavender: '#e6e6fa',
    violet: '#7f00ff',
    plum: '#8e4585',
    heather: '#9b7fa6',
    yellow: '#f5c518',
    mustard: '#ffdb58',
    gold: '#ffd700',
    ochre: '#cc7722',
    amber: '#ffbf00',
    lemon: '#fff44f',
    orange: '#f07030',
    apricot: '#fbceb1',
    'pale-yellow': '#E6EB8C',
    'light-khaki': '#C9CB9F',
    'vintage-black': '#000000',
    jam: '#674F65',
  };

  const CODE_KEYS = [
    'f75',
    'f74',
    'm00',
    'm01',
    'f84',
    'f77',
    'f76',
    'f50',
    'm06',
    'm27',
    'm36',
    'm38',
    'm37',
    'assc',
    'm58',
    'm56',
    'm90',
  ];

  function normalize(name) {
    let c = String(name || '')
      .trim()
      .toLowerCase()
      .replace(/ \/ /g, '/')
      .replace(/\/ /g, '/')
      .replace(/ \//g, '/')
      .replace(/[()]/g, '')
      .replace(/ /g, '-');

    for (const code of CODE_KEYS) {
      if (c.includes(code)) return code;
    }
    return c;
  }

  function hex(name) {
    const raw = String(name || '').trim();
    if (raw.includes('#')) return raw;
    const key = normalize(raw);
    return MAP[key] || '#808080';
  }

  window.LwSwatchColors = { hex, normalize };
})();
